import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "select-option-icon" }
const _hoisted_2 = ["aria-label", "title"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  "aria-hidden": "true"
}
const _hoisted_5 = ["aria-label", "value"]

import { computed, ref, watch } from "vue";
import ImageAssetLibrary from "@/views/ClientUIAnimationEditor/ImageAssetLibrary.vue";
import { selectIconCatalog, selectOptionIconUrl } from "../utils/selectOptionIcons";


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectOptionIcon',
  props: {
    modelValue: {},
    label: { default: "选项图标" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const open = ref(false);
const failed = ref(false);
const src = computed(() => selectOptionIconUrl(props.modelValue));
watch(src, () => { failed.value = false; });
function select(id: number | null) {
  emit("update:modelValue", id ?? 0);
  open.value = false;
}
function editId(event: Event) {
  const input = event.target as HTMLInputElement;
  const id = input.valueAsNumber;
  if (Number.isInteger(id) && id >= 0 && id <= 2147483647) emit("update:modelValue", id);
  else input.value = String(props.modelValue);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "icon-picker",
      "aria-label": `选择${__props.label}`,
      title: `${__props.label}：${__props.modelValue} · 点击选择图片`,
      onClick: _cache[1] || (_cache[1] = ($event: any) => {failed.value = false; open.value = true})
    }, [
      (src.value && !failed.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: src.value,
            alt: "",
            loading: "lazy",
            onError: _cache[0] || (_cache[0] = ($event: any) => (failed.value = true))
          }, null, 40, _hoisted_3))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.modelValue === 0 ? '—' : '▧'), 1))
    ], 8, _hoisted_2),
    _createElementVNode("input", {
      type: "number",
      class: "icon-id",
      "aria-label": `${__props.label} ID`,
      title: "图标 ID，也可点击图片选择",
      value: __props.modelValue,
      min: "0",
      max: "2147483647",
      step: "1",
      onChange: editId
    }, null, 40, _hoisted_5),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (open.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            "data-clip-editor": "",
            class: "option-icon-backdrop dsfg-typography",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (open.value = false), ["self"])),
            onPointerdown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
            onKeydown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(ImageAssetLibrary, {
              class: "option-icon-library",
              catalog: _unref(selectIconCatalog),
              "load-metadata": false,
              "selected-id": __props.modelValue || null,
              onSelect: select,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (open.value = false))
            }, null, 8, ["catalog", "selected-id"])
          ], 32))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})